import { ButtonGroup } from "@shopify/polaris";

import { GettingStartedStoreAccess } from "../../libs/store";

import SetupStep from "../SetupStep";
import { ImportExistingSubscriptionsButton } from "./ImportExistingSubscriptionsButton";
import { NewToSubscriptionsButton } from "./NewToSubscriptionsButton";
import { MigrationStep } from "../../libs/GettingStartedChecklist/MigrationStep";

export default function MigrationService() {
  const setup = GettingStartedStoreAccess.useSetup();
  const checklist = GettingStartedStoreAccess.useChecklist();

  const isStepCompleted = !!setup?.onSiteSetup.migrationService?.completed;

  return (
    <SetupStep
      title="Complementary migration service"
      description="Let us help you import your subscription programs and subscription contracts from another subscription provider."
      id="migration-service"
      statusBadgeTestId="migration-service-status-badge"
      isStepCompleted={isStepCompleted}
      isOpen={!!checklist?.isOpen(MigrationStep)}
    >
      <ButtonGroup>
        <ImportExistingSubscriptionsButton />
        <NewToSubscriptionsButton />
      </ButtonGroup>
    </SetupStep>
  );
}
